// extracted by mini-css-extract-plugin
module.exports = {"Card":"GiftCardSummaryCard_Card__3uh06","Title":"GiftCardSummaryCard_Title__D1F_s","SubTotal":"GiftCardSummaryCard_SubTotal__2OD1o"};